import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import FormEdit from '../../../../../components/auth/rh/estagiarios/listar/form_edit'
import Head from '../../../../../components/head'


function EditarEstagiariosScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Estagiário - Recursos Humanos" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarEstagiariosScreen;